export default __webpack_public_path__ + "static/media/survey.bff8bbac.png";